import { LoadingButton } from "@mui/lab";
import { Button, Grid, Stack, TextField } from "@mui/material";
import { CommonModal } from "components/molecules";
import { toNumber } from "lodash";
import { IProductionPlan } from "model";
import React, { useEffect, useState } from "react";
import { PrintActions } from "redux/actions";
import { useAppSelector } from "redux/configurations/reduxHooks";

const PrintDeliveryProgressModal = (props: {
  open: boolean;
  onConfirmPrint(printQty: number): void;
  onClose(): void;
}) => {
  const { open, onClose, onConfirmPrint } = props;
  const [printQuantity, setPrintQuantity] = useState<number | string>(0);

  const handleConfirm = () => {
    onConfirmPrint(toNumber(printQuantity));
  };

  const renderFooter = () => {
    return (
      <Footer
        disableConfirm={toNumber(printQuantity) === 0}
        onClose={onClose}
        onConfirm={handleConfirm}
      />
    );
  };

  return (
    <CommonModal
      title="Xác nhận số lượng in"
      open={open}
      FooterComponent={renderFooter()}
      handleClose={onClose}
    >
      <Grid
        sx={{ width: "100%" }}
        container
        xs={12}
        alignItems="center"
        rowGap={2}
      >
        <Grid xs={12} item>
          <TextField
            value={printQuantity}
            onChange={(event) => setPrintQuantity(event.target.value)}
            label={"Số lượng phiếu"}
            fullWidth
            type={"number"}
            InputProps={{
              inputProps: {
                min: 0,
              },
            }}
          />
        </Grid>
      </Grid>
    </CommonModal>
  );
};

const Footer = (props: {
  disableConfirm: boolean;
  onConfirm(): void;
  onClose(): void;
}) => {
  const { disableConfirm, onConfirm, onClose } = props;
  const action = useAppSelector((state) => state.PrintReducer.action);
  return (
    <Stack direction={"row"} spacing={2} justifyContent={"flex-end"}>
      <Button onClick={onClose}>Huỷ</Button>
      <LoadingButton
        loading={action.includes(PrintActions.print.requestName)}
        disabled={disableConfirm}
        onClick={onConfirm}
        variant="contained"
      >
        In
      </LoadingButton>
    </Stack>
  );
};
export default PrintDeliveryProgressModal;
